// Contributors data with LinkedIn profile information
const contributors = [
  {
    id: 1,
    name: 'תומר דהן',
    imageUrl: 'https://media.licdn.com/dms/image/v2/D4D03AQGQaXVhxJNeZQ/profile-displayphoto-shrink_800_800/B4DZWlT3ypHkAc-/0/1742235206091?e=1752105600&v=beta&t=344218pxvFkTXxqQy9xHF-dcg-EzYlXF1S6sZJpHfv0',
    linkedinUrl: 'https://www.linkedin.com/in/tomerdahan72',
  },
  {
    id: 2,
    name: 'הדר לבסקי',
    imageUrl: 'https://media.licdn.com/dms/image/v2/D4D35AQHC3CMnbqkcUA/profile-framedphoto-shrink_100_100/profile-framedphoto-shrink_100_100/0/1736860631067?e=1747508400&v=beta&t=pl20JMtioA3w1cwXxFV7oM9cWLM8MK93kW6o3PaSEME',
    linkedinUrl: 'https://www.linkedin.com/in/hadar-lavsky-1b9970342/',
  },
  {
    // make image demo  make anonymous

    id: 3,
    name: ' להוסיף מישו ',
    imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTUz5Ja3FzF7XunaGGuyHoX1S4-rOiFhCV63kb7aDD_OZMcWZBpyoApD1k7EQZ63N8-e3E&usqp=CAU',
    linkedinUrl: 'https://www.linkedin.com/in/uri-examp',
  },
  {
    id: 4,
    name: 'דרור סולם',
    imageUrl: 'https://media.licdn.com/dms/image/v2/D5635AQGXW0U7XhrOLA/profile-framedphoto-shrink_200_200/profile-framedphoto-shrink_200_200/0/1660002772504?e=1747508400&v=beta&t=OtarErn3_sDv-AIucdfMsx0ay0ZuUb1vFZZv1zjJLe8',
    linkedinUrl: 'https://www.linkedin.com/in/dror-sullam-6b226a1a0/',
  },
  {
    id: 5,
    name: 'להוסיף מישו',
    imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTUz5Ja3FzF7XunaGGuyHoX1S4-rOiFhCV63kb7aDD_OZMcWZBpyoApD1k7EQZ63N8-e3E&usqp=CAU',
    linkedinUrl: 'https://www.linkedin.com/in/uri-example',
  },
  {
    id: 6,
    name: 'אורי גבע',
    imageUrl: 'https://media.licdn.com/dms/image/v2/D4D03AQGwj6kz67ZJsw/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1705567773083?e=1752105600&v=beta&t=serxT6gdwRPxTm_8ZpVTw2LuVpReCIu3tm0nzyEdT7E',
    linkedinUrl: 'https://linkedin.com/in/oriGeva',
  },
  {
    id: 7,
    name: 'עידן מרמור',
    imageUrl: 'https://media.licdn.com/dms/image/v2/D4D03AQHtzogMadyE6w/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1691094423114?e=1752105600&v=beta&t=FZT0BKh3YSkHbCwQ8YpSiHJQhoyyz5HNmo3x9lXKkjQ',
    linkedinUrl: 'https://www.linkedin.com/in/idanmarmor',
  },
  {
    id: 8,
    name: 'דניאל שצוב',
    imageUrl: 'https://media.licdn.com/dms/image/v2/D4D35AQG19zWK3ffFaQ/profile-framedphoto-shrink_800_800/B4DZakrXd5G8Ag-/0/1746519554232?e=1747508400&v=beta&t=gT6bazQkZz8_MqrUBaodqHJ87EtCuAjQ8ePfziUMG9o',
    linkedinUrl: 'https://linkedin.com/in/daniel-shatzov',
  },
  {
    id: 9,
    name: 'דניאל זיו',
    imageUrl: 'https://media.licdn.com/dms/image/v2/C4D03AQEIGjaRizwXig/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1657953374419?e=1752105600&v=beta&t=z0e1luwBjq4d0sTEMGD3MIwXxll08pZvK_uEnQ7gsA0',
    linkedinUrl: 'https://www.linkedin.com/in/daniel-ziv/',
  },
  {
    id: 10,
    name: 'עדן',
    imageUrl: 'https://media.licdn.com/dms/image/v2/D4D03AQH-2xlRwuKdJg/profile-displayphoto-shrink_800_800/B4DZXsNwPUG8Ac-/0/1743424784739?e=1752105600&v=beta&t=zXtXCtIl8Uq_RVDuW-nf401ryWHxND3m0oWnTNzp0Co',
    linkedinUrl: 'https://www.linkedin.com/in/eden-sitkovetsky-974460238/',
  }
];

export default contributors;
